import '../styles/BankingAccount.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faCheck, faBank, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from 'react';
import { t } from 'i18next';
import UniInput from '../components/UniInput/UniInput';
import { Country, getOnlyCountries } from '../services/usefulLinkService';
import i18n from '../i18n';
import Switch from "react-switch";
import { BankAccount, getBankingAccountById, getEmptyBankAccount, BankingAccountPost, BankingAccountPut, createBankingAccount, updateBankingAccount } from '../services/bankingAccountService';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Spinner } from "react-bootstrap";
import { useUserStore } from '../store/user';
import UniModal from "../components/UniModal/UniModal";
import {PixKeyType} from "../types/pixKeyType";


const CNPJ_ALPHANUMERIC_MASK = '**.***.***/****-99';

const ManageBankingAccount = () => {
    const [isEdit, setIsEdit] = useState(false);
    const [countries, setCountries] = useState<Country[] | undefined>();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>(``);
    const [model, setModel] = useState<BankAccount>();
    let { id } = useParams();
    const [errorMessage, setErrorMessage] = useState<string>(``);
    const navigate = useNavigate();
    const [isValid, setIsValid] = useState<boolean>(false);
    const [showSuccessModel, setShowSuccessModel] = useState<boolean>(false);
    const { loginData } = useUserStore();
    const [isBrazil, setIsBrazil] = useState<boolean>(false);
    const [pixMask, setPixMask] =  useState<string>('');
    const [pixkeyEnabled, setPixkeyEnabled] = useState<boolean>(false);

    useEffect(() => {
        if (id){
            setIsEdit(true);
            setLoading(true);
            const func = async () => {
                const response = await getBankingAccountById(id ?? ``, i18n.language)
                if ((response?.success ?? false)){
                    const bankingAccount = { ...response.data };
                    const country = bankingAccount.country;
                    if (country === 'Brasil' || country === 'Brazil') {
                        if (bankingAccount.companyDocument)
                            bankingAccount.companyDocument = bankingAccount.companyDocument.toUpperCase();
                        if (Number(bankingAccount.pixKeyType) === Number(PixKeyType.CNPJ) && bankingAccount.pixKey)
                            bankingAccount.pixKey = bankingAccount.pixKey.toUpperCase();
                    }
                    setModel(bankingAccount);
                    checkIsBrazil(response.data.country);
                   // definePixMask(response.data.pixKeyType?? 3);
                   if(response.data.pixKeyType !== 0)
                    setPixkeyEnabled(true);
                }
                setLoading(false);
            }
            func();
        }
        else{
            setModel(getEmptyBankAccount())
            definePixMask(1);
        }

    },[])

    useEffect(() => {
        getGroupsLink();
    },[])

    useEffect(() => {
        setIsValid(modelIsValid());
    }, [model]);

    const getCountryDescription = (country : Country) => {
        switch (i18n.language) {
          case 'es':
            return country.descriptionES;
          case 'en':
            return country.descriptionEN;
          default:
            return country.descriptionBR;
        }
      };

      const checkIsBrazil = (country: any) => {
            if(country === 'Brasil' || country === 'Brazil')
                setIsBrazil(true);
            else
                setIsBrazil(false);
      };

      const definePixMask = (pixkeyType : number) => {

            if(pixkeyType == Number(PixKeyType.CNPJ)){
                setPixMask(CNPJ_ALPHANUMERIC_MASK);
            }
            else if(pixkeyType == Number(PixKeyType.Telephone)){
                setPixMask('(99) 99999-9999');
            }else{
                setPixMask('');
            }
      }

      const onChangeValues = (e: any, prop: string) => {
        let modelUpdated = model;
        setErrorMessage('');
        if (!modelUpdated) return;

        switch (prop) {
            case `agency`:
                modelUpdated.agency = e?.target?.value;
                break;
            case `bank`:
                modelUpdated.bank = e?.target?.value;
                break;
            case `country`: {
                modelUpdated.usefulLinksGroupEntityId = e?.target?.value;
                const countryLabel = e.target.options[e.target.selectedIndex].text;
                checkIsBrazil(countryLabel);
                if (countryLabel === 'Brasil' || countryLabel === 'Brazil') {
                    if (modelUpdated.companyDocument)
                        modelUpdated.companyDocument = modelUpdated.companyDocument.toUpperCase();
                    if (Number(modelUpdated.pixKeyType) === Number(PixKeyType.CNPJ) && modelUpdated.pixKey)
                        modelUpdated.pixKey = modelUpdated.pixKey.toUpperCase();
                }
                break;
            }
            case `companyDocument`:
                modelUpdated.companyDocument = isBrazil
                    ? (e?.target?.value ?? '').toUpperCase()
                    : e?.target?.value;
                break;
            case `companyName`:
                modelUpdated.companyName = e?.target?.value;
                break;
            case `currentAccount`:
                modelUpdated.currentAccount =  e?.target?.value;
                break;
            case `enabled`:
                modelUpdated.enabled = e;
                break;
            case `pixKey`:
                modelUpdated.pixKey =
                    isBrazil && Number(modelUpdated.pixKeyType) === Number(PixKeyType.CNPJ)
                        ? (e?.target?.value ?? '').toUpperCase()
                        : e?.target?.value;
                break;
            case `pixKeyType`:
                modelUpdated.pixKeyType = e?.target?.value;
                definePixMask(e?.target?.value);
                if(e?.target?.value != 0 ) {
                    setPixkeyEnabled(true);
                    if (Number(e?.target?.value) === Number(PixKeyType.CNPJ) && modelUpdated.pixKey)
                        modelUpdated.pixKey = modelUpdated.pixKey.toUpperCase();
                } else {
                    modelUpdated.pixKey = ``;
                    setPixkeyEnabled(false);
                }
                break;
            default:
                return;
        }

        setModel({...modelUpdated});
    }

      const getGroupsLink = () =>{
        setLoading(true)
        getOnlyCountries()
        .then(response => {
            if (!response.success) {
                setError(response.error);
            }
            else {
                setCountries(response.countries);
            }
        })
        .finally(() => setLoading(false));

    };

    const modelIsValid = (): boolean => {
        if (!model?.bank || !model?.agency || !model?.currentAccount ||
            !model?.companyName || !model?.companyDocument)
        {
            setIsValid(false);
            return false;
        }

        setIsValid(true);
        return true;
    }

    const validateEmail = (email : string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = regex.test(email);
        return isValidEmail;
    };

    /** Valor numérico do caractere para módulo 11 (Nota Técnica RFB: código ASCII − 48) */
    const charToValue = (char: string): number => char.charCodeAt(0) - 48;

    const validateCNPJ = (cnpj: string) => {
        const b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        const c = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');

        if (c.length !== 14) return false;

        if (c[12] < '0' || c[12] > '9' || c[13] < '0' || c[13] > '9') return false;

        // evita repetidos tipo AAAA...
        if (/^([A-Z0-9])\1+$/.test(c)) return false;

        let n = 0;

        // 1º dígito
        for (let i = 0; i < 12; i++) {
            n += charToValue(c[i]) * b[i + 1];
        }

        let dv1 = n % 11 < 2 ? 0 : 11 - (n % 11);

        if (charToValue(c[12]) !== dv1) return false;

        n = 0;

        // 2º dígito
        for (let i = 0; i < 13; i++) {
            n += charToValue(c[i]) * b[i];
        }

        let dv2 = n % 11 < 2 ? 0 : 11 - (n % 11);

        if (charToValue(c[13]) !== dv2) return false;

        return true;
    };

    const validateCuit = (cuitOrCuil: string) => {
        if (!/^\d{2}-\d{8}-\d$/.test(cuitOrCuil)) {
          return false;
        }

        var cuitOrCuilNoDash = cuitOrCuil.replace(/-/g, '');
        var checkDigit = parseInt(cuitOrCuilNoDash.charAt(10));
        var checkSum = 0;
        var multiplier = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

        for (var i = 0; i < 10; i++) {
          checkSum += parseInt(cuitOrCuilNoDash.charAt(i)) * multiplier[i];
        }

        var result = (11 - checkSum % 11) % 11;
        return result === checkDigit;
      }

    const savebankingAccount = () => {
        setLoading(true);

        if (!modelIsValid()) {
            setErrorMessage(t('banking.fieldsErrorMessage'));
            setLoading(false);
            return;
        }
        if(isBrazil){
            var keyType:number = model?.pixKeyType ?? 1;

            if(keyType == Number(PixKeyType.Email)){
                if(!validateEmail(model?.pixKey ?? '')){
                    setErrorMessage(t('banking.emailPixError'));
                    setLoading(false);
                    return;
                }
            }
            if(keyType == Number(PixKeyType.CNPJ)){
                if(!validateCNPJ(model?.pixKey ?? '')){
                    setErrorMessage(t('banking.cnpjPixError'));
                    setLoading(false);
                    return;
                }
            }
            if(!validateCNPJ(model?.companyDocument ?? '')){
                setErrorMessage(t('banking.documentError'));
                setLoading(false);
                return;
            }
        }else{
            if(!validateCuit(model?.companyDocument ?? '')){
                setErrorMessage(t('banking.documentError'));
                setLoading(false);
                return;
            }
        }

        if (!isEdit) {
            const bankingAccountInsert: BankingAccountPost = {
                bank: model?.bank ?? ``,
                agency: model?.agency ?? ``,
                currentAccount: model?.currentAccount ?? ``,
                pixKeyType: model?.pixKeyType ?? 1,
                pixKey: model?.pixKey ?? ``,
                enabled: true,
                companyName: model?.companyName ?? ``,
                companyDocument: model?.companyDocument ?? ``,
                createdBy: loginData.email,
                usefulLinksGroupEntityId: model?.usefulLinksGroupEntityId === '' ? countries?.[0]?.id ?? `` :  model?.usefulLinksGroupEntityId ?? ''
            };

            createBankingAccount(bankingAccountInsert)
            .then(response => {
                if (!response.success) {
                    setError(response.error ?? '');
                }
                else {
                    setShowSuccessModel(true);
                }
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false));
        } else {
            const bankingAccountUpdate: BankingAccountPut = {
                id: model?.id ?? ``,
                bank: model?.bank ?? ``,
                agency: model?.agency ?? ``,
                currentAccount: model?.currentAccount ?? ``,
                pixKeyType: isBrazil ? model?.pixKeyType ?? 0 : 0,
                enabled: model?.enabled ?? false,
                pixKey: isBrazil ? model?.pixKey ?? `` : ``,
                companyName: model?.companyName ?? ``,
                companyDocument: model?.companyDocument ?? ``,
                modifiedBy: loginData.email,
                usefulLinksGroupEntityId: model?.usefulLinksGroupEntityId === '' ? countries?.[0]?.id ?? `` : model?.usefulLinksGroupEntityId ?? ''
            };

            updateBankingAccount(bankingAccountUpdate, model?.id ?? ``)
            .then(response => {
                if (!response.success) {
                    setError(response.error ?? '');
                }
                else {
                    setShowSuccessModel(true);
                }
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false));
        }
    }

    return (
        <>
            <div className="banking-account-wrapper">
                <div className='banking-account-header w-100'>
                    <div className='banking-account-header-i'>
                        <FontAwesomeIcon icon={faBank} color='#00FF3C' size='xl' />
                        <p className='w-100'>{isEdit ? t('banking.edit') : t('banking.new')}</p>
                    </div>
                </div>
                <div className="p-5 w-100">
                    <div className='d-flex gap-4 mb-3 flex-wrap'>
                        <div>
                            <UniInput
                                id='country'
                                label={t('banking.country')}
                                isSelect
                                value={model?.usefulLinksGroupEntityId}
                                defaultValue={model?.usefulLinksGroupEntityId}
                                onChange={(e) => onChangeValues(e, 'country')}
                            >
                                    {countries?.map(country => (
                                        <option key={country.id} value={country.id}>
                                        { getCountryDescription(country)}
                                        </option>
                                    ))}
                            </UniInput>
                        </div>
                        {
                            isEdit && (
                                <div className="d-flex gap-2 align-items-center">
                                    {t('banking.active')}
                                    <Switch
                                        onChange={(e) => { onChangeValues(e, 'enabled')}}
                                        disabled={loading}
                                        checked={model?.enabled ?? true}
                                        height={20}
                                        width={40}
                                    />
                                </div>
                            )
                        }
                    </div>
                    <div className='d-flex gap-3 mb-2 flex-wrap'>
                        <div>
                            <UniInput
                                id='bank'
                                disabled={loading}
                                placeholder=''
                                label={t('banking.bank') + '*'}
                                type='text'
                                value={model?.bank}
                                onChangeInput={(e) => onChangeValues(e, 'bank')}
                            />
                        </div>
                        <div>
                            <UniInput
                                id='agency'
                                disabled={loading}
                                placeholder=''
                                label={ t('banking.agency') + '*'}
                                type='text'
                                value={model?.agency}
                                onChangeInput={(e) => onChangeValues(e, 'agency')}
                            />
                        </div>
                        <div>
                            <UniInput
                                id='currentAccount'
                                disabled={loading}
                                placeholder=''
                                label={t('banking.account') + '*'}
                                type='text'
                                value={model?.currentAccount}
                                onChangeInput={(e) => onChangeValues(e, 'currentAccount')}
                            />
                        </div>
                    </div>
                    { isBrazil && (
                    <div className='d-flex gap-3 mb-2 flex-wrap'>
                        <div>
                        <UniInput
                            id='pixKeyType'
                            label={t('banking.pixKeyType')}
                            isSelect
                            onChange={(e) => onChangeValues(e, 'pixKeyType')}
                            value={model?.pixKeyType}
                            >
                            <option key='0' value={'0'}>{t('select')}</option>
                            <option key='1' value={'1'}>CNPJ</option>
                            <option key='2' value={'2'}>Email</option>
                            <option key='3' value={'3'}>{t('banking.phone')}</option>

                        </UniInput>
                        </div>
                        <div>
                            <UniInput
                                id='pixKey'
                                disabled={!pixkeyEnabled}
                                placeholder=''
                                label={t('banking.pixKey')}
                                type='text'
                                mask={pixMask ?? undefined}
                                value={model?.pixKey}
                                onChangeInput={(e) => onChangeValues(e, 'pixKey')}
                            />
                        </div>
                    </div>)
                    }
                    <div className='d-flex gap-3 mb-2 flex-wrap'>
                        <div>
                            <UniInput
                                id='companyName'
                                disabled={loading}
                                placeholder=''
                                label={t('banking.companyName') + '*'}
                                type='text'
                                value={model?.companyName}
                                onChangeInput={(e) => onChangeValues(e, 'companyName')}
                            />
                        </div>
                        <div>
                            <UniInput
                                id='companyDocument'
                                disabled={loading}
                                placeholder=''
                                label={t('banking.companyDocument') + '*'}
                                type='text'
                                mask= {isBrazil ? CNPJ_ALPHANUMERIC_MASK : '99-99999999-9'}
                                value={model?.companyDocument}
                                onChangeInput={(e) => onChangeValues(e, 'companyDocument')}
                            />
                        </div>
                    </div>

                    <div className='d-flex justify-content-end gap-3'>
                        {
                            errorMessage && (<b>{errorMessage}</b>)
                        }
                        <Button variant='secondary' onClick={() => navigate('/banking-account')}>
                            {t('back')}
                        </Button>
                        <Button variant='primary'   onClick={loading ? () => {} : () => savebankingAccount()}>
                            {loading ? <Spinner color="#fff"/> : t('save')}
                        </Button>
                    </div>
                </div>
            </div>

            <UniModal
                icon={faXmarkCircle}
                message=''
                iconColor='#EA2027'
                title={error || t('error')}
                onHide={() => {setError('')}}
                show={error !== ''}
                isFontAwsome
            />

            <UniModal
                icon={faCheck}
                isFontAwsome
                iconColor='#00FF3C'
                title={t('successTitle')}
                message={t('success')}
                show={showSuccessModel}
                onHide={() => {
                    setShowSuccessModel(false);
                    navigate('/banking-account');
                }}
                iconWidth={100}
                iconHeight={100}
            >
                <div>
                    <Button
                        className="mt-3"
                        onClick={() => {
                            setShowSuccessModel(false);
                            navigate('/banking-account');
                        }
                    }>
                        OK
                    </Button>
                </div>
            </UniModal>
        </>
    );
}

export default ManageBankingAccount;